export default "__VITE_ASSET__CbTr1qeG__"